
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Redirect } from '@/types/redirects';

@Component({})
export default class AddRedirectDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop() redirect!: Redirect;

  onSave() {
    this.$emit('submit');
    this.$emit('input', false);
  }
}
